import { ChartBar, LineChart, PieChart, Database } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const AnalyticsHero = () => {
  return (
    <section className="relative pt-20 pb-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900 to-blue-800" />
      <div className="absolute inset-0 bg-grid-white/[0.05]" />
      
      <div className="relative max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-8">
            <h1 className="text-5xl font-bold leading-tight">
              Transform Your Data Into
              <span className="bg-gradient-to-r from-blue-200 to-blue-400 bg-clip-text text-transparent">
                {" "}Actionable Insights with AI Agents
              </span>
            </h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              Empower your business with AI-driven agents that automate reporting, analyze complex data, 
              and deliver actionable insights in real time—fueling growth, innovation, and smarter decisions.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contact">
                <Button size="lg" className="bg-white text-blue-900 hover:bg-blue-50">
                  Get Started
                </Button>
              </Link>
              <Link to="/case-studies">
                <Button 
                  size="lg" 
                  variant="outline" 
                  className="border-2 border-white text-white bg-white/10 hover:bg-white/20"
                >
                  View Case Studies
                </Button>
              </Link>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-6">
            {[
              {
                icon: <ChartBar className="h-8 w-8 mb-4" />,
                title: "AI-Driven Data Visualization",
                description: "Interactive dashboards and automated reports, powered by AI agents that process and present your data in real time"
              },
              {
                icon: <LineChart className="h-8 w-8 mb-4" />,
                title: "Predictive Analytics Agents",
                description: "AI agents forecast trends, identify patterns, and deliver actionable predictions to stay ahead of the curve"
              },
              {
                icon: <PieChart className="h-8 w-8 mb-4" />,
                title: "Smart Business Metrics",
                description: "AI-powered performance tracking that automatically monitors KPIs and provides instant insights to optimize decisions"
              },
              {
                icon: <Database className="h-8 w-8 mb-4" />,
                title: "AI-Powered Data Integration",
                description: "Unified data pipelines managed by AI agents, ensuring seamless integration from multiple sources for complete visibility"
              }
            ].map((feature, index) => (
              <div 
                key={index}
                className="p-6 rounded-xl bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-colors text-white"
              >
                {feature.icon}
                <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
                <p className="text-blue-100 text-sm">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};